import {
	EnhancementEnablement
} from './enhancements';

export interface IEnhancementToken {
  exp: number, // When the token expires (we'll compare exact but allow a couple minutes of clock skew on the backend)
  value: string, // The actual value of the token
}

// If you ever change this, you must looks for 
// hack[rollup-enums] to find all the places we had to hard code
// values so we could get rollup to compile our ts.
export enum EnhancementHostConfigType {
  Regex = 'regex',
  Exact = 'exact'
}

export type IEnhancementHostConfigRegex = {
  id: string,

  type: EnhancementHostConfigType.Regex,

  hostRegex: RegExp,

  // If there is no token, assume it's dev and allow it
  token?: IEnhancementToken,

  // If there are no enhancements, assume all 
  // the backend will subtract from what's granted via the token
  enhancements?: EnhancementEnablement[],

  environment?: string,
}

export type IEnhancementHostConfigExact =  {
  id: string,

  type: EnhancementHostConfigType.Exact,

  host: string,

  // If there is no token, assume it's dev and allow it
  token?: IEnhancementToken,

  // If there are no enhancements, assume all 
  // the backend will subtract from what's granted via the token
  enhancements?: EnhancementEnablement[],

  environment?: string,
}

export type IEnhancementHostConfig =
  | IEnhancementHostConfigExact
  | IEnhancementHostConfigRegex

// Configuration of what hosts & what enhancements  
export interface IEnhancementConfig {
  allLocalhost?: boolean,
  hosts: IEnhancementHostConfig[],
}

// Stored on a given request to indicate which enahancements we should
// be expecting to get back. 
export interface IEnhancementRecord {
  // Non implies all
  enhancements?: EnhancementEnablement[],
  hostId?: string,
  enhancementHostConfig?: IEnhancementHostConfigExact,
}

